import { render, staticRenderFns } from "./KeyValueSection.vue?vue&type=template&id=a90c9504&scoped=true"
import script from "./KeyValueSection.vue?vue&type=script&lang=ts"
export * from "./KeyValueSection.vue?vue&type=script&lang=ts"
import style0 from "./KeyValueSection.vue?vue&type=style&index=0&id=a90c9504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90c9504",
  null
  
)

export default component.exports